import { COMMENT as B, DECLARATION as F, RULESET as G } from "./Enum.js";
import { strlen as E, append as L, charat as I, replace as z, indexof as H, sizeof as J, substr as N, abs as K, trim as P, from as q } from "./Utility.js";
import { dealloc as Q, alloc as V, next as O, peek as R, delimit as x, identifier as W, commenter as X, escaping as Y, whitespace as Z, node as D, char as _, prev as $, caret as y } from "./Tokenizer.js";
function ca(e) {
  return Q(M("", null, null, null, [""], e = V(e), 0, [0], e));
}
function M(e, o, n, i, m, w, g, v, T) {
  for (var l = 0, d = 0, r = g, h = 0, u = 0, b = 0, f = 1, A = 1, s = 1, c = 0, k = "", C = m, p = w, t = i, a = k; A; )
    switch (b = c, c = O()) {
      case 40:
        if (b != 108 && I(a, r - 1) == 58) {
          H(a += z(x(c), "&", "&\f"), "&\f") != -1 && (s = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        a += x(c);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        a += Z(b);
        break;
      case 92:
        a += Y(y() - 1, 7);
        continue;
      case 47:
        switch (R()) {
          case 42:
          case 47:
            L(j(X(O(), y()), o, n), T);
            break;
          default:
            a += "/";
        }
        break;
      case 123 * f:
        v[l++] = E(a) * s;
      case 125 * f:
      case 59:
      case 0:
        switch (c) {
          case 0:
          case 125:
            A = 0;
          case 59 + d:
            u > 0 && E(a) - r && L(u > 32 ? U(a + ";", i, n, r - 1) : U(z(a, " ", "") + ";", i, n, r - 2), T);
            break;
          case 59:
            a += ";";
          default:
            if (L(t = S(a, o, n, l, d, m, v, k, C = [], p = [], r), w), c === 123)
              if (d === 0)
                M(a, o, t, t, C, w, r, v, p);
              else
                switch (h === 99 && I(a, 3) === 110 ? 100 : h) {
                  case 100:
                  case 109:
                  case 115:
                    M(e, t, t, i && L(S(e, t, t, 0, 0, m, v, k, m, C = [], r), p), m, p, r, v, i ? C : p);
                    break;
                  default:
                    M(a, t, t, t, [""], p, 0, v, p);
                }
        }
        l = d = u = 0, f = s = 1, k = a = "", r = g;
        break;
      case 58:
        r = 1 + E(a), u = b;
      default:
        if (f < 1) {
          if (c == 123)
            --f;
          else if (c == 125 && f++ == 0 && $() == 125)
            continue;
        }
        switch (a += q(c), c * f) {
          case 38:
            s = d > 0 ? 1 : (a += "\f", -1);
            break;
          case 44:
            v[l++] = (E(a) - 1) * s, s = 1;
            break;
          case 64:
            R() === 45 && (a += x(O())), h = R(), d = r = E(k = a += W(y())), c++;
            break;
          case 45:
            b === 45 && E(a) == 2 && (f = 0);
        }
    }
  return w;
}
function S(e, o, n, i, m, w, g, v, T, l, d) {
  for (var r = m - 1, h = m === 0 ? w : [""], u = J(h), b = 0, f = 0, A = 0; b < i; ++b)
    for (var s = 0, c = N(e, r + 1, r = K(f = g[b])), k = e; s < u; ++s)
      (k = P(f > 0 ? h[s] + " " + c : z(c, /&\f/g, h[s]))) && (T[A++] = k);
  return D(e, o, n, m === 0 ? G : v, T, l, d);
}
function j(e, o, n) {
  return D(e, o, n, B, q(_()), N(e, 2, -2), 0);
}
function U(e, o, n, i) {
  return D(e, o, n, F, N(e, 0, i), N(e, i + 1, -1), i);
}
export {
  j as comment,
  ca as compile,
  U as declaration,
  M as parse,
  S as ruleset
};
//# sourceMappingURL=Parser.js.map
